"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payload = void 0;
const updateModel = {
    data: {
        type: 'booking',
        attributes: {
            booking_services_attributes: [],
        },
    },
};
class Payload {
    constructor(service, services) {
        this.model = updateModel;
        const localServices = [...services];
        const serviceInBookingIndex = localServices.findIndex((currentService) => String(currentService.id) === String(service.id));
        if (serviceInBookingIndex >= 0) {
            localServices[serviceInBookingIndex] = {
                id: localServices[serviceInBookingIndex].id,
                price_cents: service.price_cents,
                service_kind: service.service_kind,
                vat_percentage: service.vat_percentage,
                tax_rate: service.tax_rate,
                taxable: service.taxable,
            };
        }
        if (serviceInBookingIndex < 0) {
            localServices.push({
                price_cents: service.price_cents,
                service_kind: service.service_kind,
                vat_percentage: service.vat_percentage,
                tax_rate: service.tax_rate,
                taxable: service.taxable,
            });
        }
        this.model.data.attributes.booking_services_attributes = localServices;
    }
}
exports.Payload = Payload;
//# sourceMappingURL=model.js.map